import { useAppContext } from './AppContext'

export const useHeader = () => {
  const { headerFooter } = useAppContext();
  // get top nav of the blog
  const header  = headerFooter?.header?.length ? headerFooter?.header[0] : {};

  return header;
}
